import React, { useState, useEffect, useContext } from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid,
  Chip
} from '@material-ui/core';
import _ from 'lodash';

import { Payment } from '../';
import config from '../../../../config/config.json';
import OrderContext from '../../../../context/orderContext';

import { useSelector } from 'react-redux';
import {
  getTicketCouponsPriceSelector,
  getTicketCustomerTypeSelector
} from '../../../../store/ticket';

const Payments = props => {
  const orderContext = useContext(OrderContext);
  const customerType = useSelector(getTicketCustomerTypeSelector);

  // console.log('orderContext.actionType', orderContext.actionType);

  const currenciesRate = config.currenciesRate;

  const [payments, setPayments] = useState([]);
  const [defaultPayment, setDefaultPayment] = useState(0);
  const [maxIndex, steMaxIndex] = useState(0);
  const [payedStatus, setPayedStatus] = useState('unpayd');
  const [currentPaymentAmount, setCurrentPaymentAmount] = useState(0);
  const [currentOverpaymentAmount, setCurrentOverpaymentAmount] = useState(0);

  const payedStatusLabels = config.payedStatusLabels;

  const couponsPrice = useSelector(getTicketCouponsPriceSelector);
  // console.log('couponsPrice',couponsPrice);
  // console.log('price', props.price, props.ticketPayments);

  useEffect(() => {
    const priceRemain = getPriceRemain();
    setDefaultPayment(priceRemain);
    // }, [props.price,props.customer.type]);
  }, [props.price]);

  useEffect(() => {
    setPayments(props.ticketPayments);
  }, [props.ticketPayments]);

  const getPaymentLabel = () => {
    if (orderContext.actionType === 'edit') {
      if (!props.ticketStatus) return '';
      const key = Object.keys(payedStatusLabels).filter(
        key => payedStatusLabels[key].id === props.ticketStatus
      )[0];
      return payedStatusLabels[key].label;
    } else {
      return payedStatusLabels[payedStatus]
        ? payedStatusLabels[payedStatus]['label']
        : '';
    }
  };
  const getPaymentLabelColor = () => {
    if (orderContext.actionType === 'edit') {
      if (!props.ticketStatus) return '#e0e0e0';
      const key = Object.keys(payedStatusLabels).filter(
        key => payedStatusLabels[key].id === props.ticketStatus
      )[0];
      return payedStatusLabels[key].color;
    } else {
      return payedStatusLabels[payedStatus]
        ? payedStatusLabels[payedStatus]['color']
        : '#e0e0e0';
    }
  };

  const getPriceRemain = (paymentsNew = false) => {
    // console.log('priceRemain', props.price, payments, paymentsNew)
    // console.log('priceRemain', paymentsNew)

    // Еще одна магия если в режиме редактирования то берем стоимость купонов, иначе берем вычисленный прайс
    const price =
      orderContext.actionType === 'edit' ? couponsPrice : props.price;

    const currentPayment = paymentsNew ? paymentsNew : payments;

    // console.log('priceRemain sum', props.price, _.sumBy(currentPayment, function(o) { return parseInt(o.payment.amount); }))
    const currentPaymentAmountNem = _.isEmpty(currentPayment)
      ? 0
      : _.sumBy(currentPayment, function(o) {
          return (
            parseInt(o.payment.amount) * currenciesRate[o.payment.currency]
          );
        });

    // console.log('currentPaymentAmountNem', currentPayment, currentPaymentAmountNem);

    setCurrentPaymentAmount(currentPaymentAmountNem);
    props.onChangeСurrentPaymentAmount(currentPaymentAmountNem);

    const defaultPriceRemain = price - currentPaymentAmountNem;
    setCurrentOverpaymentAmount(defaultPriceRemain * -1);

    // Установим новый статус опалтыЖ полностью, частично или не оплачено
    // console.log('props.users', props.customer);
    const payedStatusNew =
      parseInt(customerType) === 2
        ? 'payd'
        : price <= 0
        ? 'unpayd'
        : defaultPriceRemain <= 0
        ? 'payd'
        : currentPaymentAmountNem > 0
        ? 'partly'
        : 'unpayd';

    // console.log('props.customer.type', props.customer.type);
    // console.log('price', price);
    // console.log('defaultPriceRemain', defaultPriceRemain);
    // console.log('currentPaymentAmountNem', currentPaymentAmountNem);
    // console.log('payedStatusNew', payedStatusNew);

    setPayedStatus(payedStatusNew);
    props.onChangePayedStatus(payedStatusLabels[payedStatusNew].id);
    // console.log('priceRemain defaultPriceRemain', defaultPriceRemain)

    return defaultPriceRemain;
    // return defaultPriceRemain > 0 ? defaultPriceRemain : 0
  };

  const handelAddPayment = (payment, index) => {
    // console.log('handelAddPayment', payment, index)
    const pamentNew = [...payments, { index, payment }];
    setPayments(pamentNew);
    props.onChangePayment(pamentNew);
    steMaxIndex(maxIndex + 1);
    const priceRemain = getPriceRemain(pamentNew);
    setDefaultPayment(priceRemain);
  };

  const handelChangePayment = (payment, index) => {
    // console.log('handelChangePayment', payment, index)
    // handelDeletePayment(index)
    // handelAddPayment(payment, index)
    const paymentsDeleted = _.filter([...payments], function(o) {
      return o.index !== index;
    });

    const pamentNew = [...paymentsDeleted, { index, payment }];
    setPayments(pamentNew);
    props.onChangePayment(pamentNew);

    steMaxIndex(maxIndex + 1);
    const priceRemain = getPriceRemain(pamentNew);
    setDefaultPayment(priceRemain);
  };

  const handelDeletePayment = index => {
    // props.onDeletePayment(index)
    // console.log('handelDeletePayment', index)
    const paymentsNew = _.filter([...payments], function(o) {
      return o.index !== index;
    });
    setPayments(paymentsNew);
    props.onChangePayment(paymentsNew);

    const priceRemain = getPriceRemain(paymentsNew);
    // console.log('handelDeletePayment priceRemain',priceRemain)
    setDefaultPayment(priceRemain);
  };

  return (
    <Card
    // {...rest}
    // className={clsx(classes.root, className)}
    >
      <form autoComplete="off" noValidate>
        <CardHeader
          title="Платежи"
          subheader={
            currentOverpaymentAmount > 0
              ? `Переплата: ${currentOverpaymentAmount.toLocaleString(
                  'ru'
                )} ฿, ${Math.round(
                  currentOverpaymentAmount / currenciesRate[2]
                ).toLocaleString('ru')} $, ${Math.round(
                  currentOverpaymentAmount / currenciesRate[3]
                ).toLocaleString('ru')} €, ${Math.round(
                  currentOverpaymentAmount / currenciesRate[5]
                ).toLocaleString('ru')} Д`
              : ''
          }
          // subheader={currentPaymentAmount > 0 ? `Итого: ${currentPaymentAmount} ฿` : "" }
          action={
            <Chip
              style={{
                backgroundColor: `${getPaymentLabelColor()}`
              }}
              label={getPaymentLabel()}
            />
          }
        />
        <Divider />
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Grid
                container
                direction="column"
                justify="flex-start"
                alignItems="stretch"
                spacing={3}>
                <Grid item xs={12}>
                  <Payment
                    defaultPayment={defaultPayment}
                    index={maxIndex}
                    onAddPayment={handelAddPayment}
                    type={'add'}
                    currenciesRate={currenciesRate}
                  />
                </Grid>

                <Grid item xs={12}>
                  {payments &&
                    !_.isEmpty(payments) &&
                    payments.map((p, index) => (
                      <Payment
                        key={p.index}
                        index={p.index}
                        payment={p.payment}
                        onChangePayment={handelChangePayment}
                        onDeletePayment={handelDeletePayment}
                        // onDeletePayment={handelDeletePayment}
                        type="view"
                      />
                    ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </CardContent>
      </form>
    </Card>
  );
};

export default Payments;
